import { AbstractModel } from '.';

class model extends AbstractModel {
    endpoint = 'location';

    async saveQuestLocaion(location) {
        if (location.id) {
            return this.update(location.id, {
                params: {
                    'response-group': 'location_short',
                },
                body: location,
            });
        } else if (location.name) {
            return this.create({
                params: {
                    'response-group': 'location_short',
                },
                body: location,
            });
        }
    }
}

export const LocationModel = new model();
